import { Link } from "react-router-dom";
import { COUNTRIES } from "../data";
import "./Footer.css";

export default function Footer() {
  const NAV_DESTINATIONS = Object.values(COUNTRIES);

  return (
    <footer className="footer">

      {/* ── Top row: Brand, Quick Links, Study Destinations, Contact ── */}
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="footer-logo-link">
            <img src="/assets/TRANSPARENT_LOGO.png" alt="ISTP Overseas Logo" className="footer-logo-img" />
          </Link>
          <p className="footer-brand-desc">
            Vijayawada's most trusted overseas education consultancy. Turning study abroad dreams into reality since 2014.
          </p>
          <div className="footer-social">
            <a href="https://www.instagram.com/istpoverseaseducation/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a href="https://wa.me/919110714332" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="WhatsApp">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.878-1.42C8.34 21.47 10.13 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/>
              </svg>
            </a>
            <a href="https://maps.app.goo.gl/hbTNY9V66giUicr19" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Google Maps">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-links-group">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/student-meets">Student Meets</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/book-slot">Book Counselling</Link></li>
          </ul>
        </div>

        <div className="footer-links-group">
          <h4 className="footer-title">Study Destinations</h4>
          <ul className="footer-links">
            {NAV_DESTINATIONS.map((dest) => (
              <li key={dest.slug}>
                <Link to={`/study-in/${dest.slug}`}>
                  {dest.flag} Study in {dest.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-links-group">
          <h4 className="footer-title">Contact Us</h4>
          <div className="footer-contact">
            <a href="tel:+919110714332" className="footer-contact-item">
              <span className="footer-contact-icon">📞</span>
              <span>+91 91107 14332</span>
            </a>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📍</span>
              <span>1st Floor, KP Street, Thota's Vivedha Apartment, Bunder Rd, near PVP Mall, Vijayawada, AP 520010</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">🕐</span>
              <span>Mon–Sat: 9:00 AM – 7:00 PM</span>
            </div>
          </div>
          <Link to="/book-slot" className="footer-cta-btn">Book Free Counselling →</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} ISTP Overseas Education Consultant &amp; Immigration. All rights reserved.</span>
        <span className="footer-bottom-tagline">Design and Developed by <a href="https://www.aigenswift.com" target="_blank">aigenswift</a></span>
      </div>
    </footer>
  );
}